import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, InjectionToken, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BarcodeFormat } from '@zxing/library';
import { MdlDialogReference } from '@angular-mdl/core';
import { maxLengthInBytes } from '../../../shared/validators';

export const ADDITIONAL_CONTAINER_TOKEN = new InjectionToken('Additional-Container-Token');

export interface AdditionalContainerInfo {
    barcode?: string;
    reason?: string;
    isMatchingAccession?: boolean;
    errorText?: string;
    addContainer?: boolean;
}

@Component({
    selector: 'additional-container',
    template: require('./additional-container.component.html'),
    styles: [require('./additional-container.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalContainerComponent {

    public containerRequest: AdditionalContainerInfo;
    public intendedUseFormControl = new FormControl('', maxLengthInBytes(100));
    public containerBarcode = '';

    constructor(
        private dialog: MdlDialogReference,
        @Inject(ADDITIONAL_CONTAINER_TOKEN) private readonly messageRequest: AdditionalContainerInfo) {

        this.containerRequest = messageRequest;
    }

    public onCancel() {
        this.containerRequest.addContainer = false;
        this.dialog.hide(null);
    }

    public onNext() {
        this.containerRequest.reason = this.intendedUseFormControl.value;
        this.containerRequest.addContainer = true;
        this.dialog.hide(this.containerRequest);
    }
}
